module.exports = __webpack_public_path__ + "static/client3-c533d188997e2d1805ca5f1ab38f1abb.png";